import { store } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import { StoreMixin } from '../../utility/store-mixin';
import '../../common/bn-action';
import '../../common/bn-flash';

class ExportBinsModal extends StoreMixin(BnModalMixin(LitEntity)) {
  constructor() {
    super();
    this.id = 'export-bins-modal';
    this._stateChanged(store.getState());
  }

  static get properties() {
    return {
      actionHref: { type: String, attribute: false },
      binsHref: { type: String, attribute: false },
    };
  }

  renderContents() {
    return html`
      <style>
        #export-bins-modal {
          --modal-min-width: 50%;
        }
        :host {
          text-align: center;
        }
        organization-ancestors-bread-crumbs {
          display: inline;
          min-width: calc(100% - 300px);
        }
        .adding-into {
          margin-top: 0.75em;
          display: flex;
          margin-bottom: 1em;
          opacity: .7;
        }
        h3 {
          margin: 0;
        }
        p {
          text-align: center;
          margin: 1em 0 0 0;
        }
        p.dynamic {
          margin: 0 0 2em 0;
          color: var(--black-base);
        }
      </style>

      <h3 slot="title">Export Bin Levels</h3>
      <bn-flash id="status"></bn-flash>

      <p>Request a csv export of all bin levels from</p>
      <p class="dynamic">
        <organization-ancestors-bread-crumbs .href="${this.href}" linkPath="" ancestorMinIndex="0">
        </organization-ancestors-bread-crumbs>
      </p>
      <p>Upon completion, the csv will be emailed to</p>
      <p class="dynamic">
        <user-email .href="${this.userHref}"></user-email>
      </p>
      <p>This request will take 5 - 10 minutes to complete</p>
      <p>
        <bn-action
          .href="${this.binsHref}"
          submittext="Request"
          actionname="request-csv-export"
          successtext="Your request is being processed, an email will arrive shortly with a link to the csv file."
          errortext="Your request was unable to be processed."
        >
          <span slot="header"></span>
        </bn-action>
      </p>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }

    this.binsHref = this.getHref('https://api.binsentry.com/rel/v2/bins');
  }

  _stateChanged({ currentUserHref }) {
    this.userHref = currentUserHref;
  }
}

window.customElements.define('export-bins-modal', ExportBinsModal);
